var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42516 17.225C7.26683 17.225 7.1085 17.1667 6.9835 17.0417C6.74183 16.8 6.74183 16.4 6.9835 16.1583L12.4168 10.725C12.8168 10.325 12.8168 9.67502 12.4168 9.27502L6.9835 3.84168C6.74183 3.60002 6.74183 3.20002 6.9835 2.95835C7.22516 2.71668 7.62516 2.71668 7.86683 2.95835L13.3002 8.39168C13.7252 8.81668 13.9668 9.39168 13.9668 10C13.9668 10.6084 13.7335 11.1834 13.3002 11.6084L7.86683 17.0417C7.74183 17.1584 7.5835 17.225 7.42516 17.225Z",
    fill: "#117FD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right_blue.07dfc424fd9c550ed5e0f1fe4c755fcf.svg";
export { ForwardRef as ReactComponent };